import { useState } from 'react';

export const useFilterError = () => {
  const [errors, setErrors] = useState<Record<string, boolean>>({});

  const attachError = (name: string) => (isError: boolean) => {
    setErrors((prev) => {
      if (prev[name] === isError) return prev;
      return { ...prev, [name]: isError };
    });
  };

  const isValid = !Object.values(errors).some(Boolean);

  return { isValid, attachError };
};
